import React, { useLayoutEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { TopMenuStyle } from "./Style";

function TopMenu() {
  const { t } = useTranslation();
  const path = "/admin";

  useLayoutEffect(() => {
    const active = document.querySelector(".hexadash-top-menu a.active");
    const activeDefault = () => {
      const megaMenu = active.closest(".megaMenu-wrapper");
      const hasSubMenuLeft = active.closest(".has-subMenu-left");
      if (!megaMenu) {
        active.closest("ul").previousSibling.classList.add("active");
        if (hasSubMenuLeft)
          hasSubMenuLeft.closest("ul").previousSibling.classList.add("active");
      } else {
        active
          .closest(".megaMenu-wrapper")
          .previousSibling.classList.add("active");
      }
    };
    window.addEventListener("load", active && activeDefault);
    return () => window.removeEventListener("load", activeDefault);
  }, []);

  const addParentActive = (event) => {
    document.querySelectorAll(".parent").forEach((element) => {
      element.classList.remove("active");
    });

    const hasSubMenuLeft = event.currentTarget.closest(".has-subMenu-left");
    const megaMenu = event.currentTarget.closest(".megaMenu-wrapper");
    if (!megaMenu) {
      event.currentTarget.closest("ul").previousSibling.classList.add("active");
      if (hasSubMenuLeft)
        hasSubMenuLeft.closest("ul").previousSibling.classList.add("active");
    } else {
      event.currentTarget
        .closest(".megaMenu-wrapper")
        .previousSibling.classList.add("active");
    }
  };

  return (
    <TopMenuStyle>
      <div className="hexadash-top-menu ltr:pl-[20px] rtl:pr-[20px] xl:ltr:pl-[10px] xl:rtl:pr-[10px] ">
        <ul>
          {/* New Menu */}
          <li className="has-subMenu">
            <Link to="#" className="parent">
              {t("members.members")}
            </Link>
            <ul className="subMenu">
              <li>
                <NavLink to={`${path}/members`} onClick={addParentActive}>
                  {t("members.membersList")}
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="has-subMenu">
            <Link to="#" className="parent">
              {t("users.users")}
            </Link>
            <ul className="subMenu">
              <li>
                <NavLink to={`${path}/users`} onClick={addParentActive}>
                  {t("users.usersList")}
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="has-subMenu">
            <Link to="#" className="parent">
              {t("settings.settings")}
            </Link>
            <ul className="subMenu">
              <li>
                <NavLink to={`${path}/activities`} onClick={addParentActive}>
                  {t("activities.activities")}
                </NavLink>
              </li>
              <li>
                <NavLink to={`${path}/countries`} onClick={addParentActive}>
                  {t("countries.countries")}
                </NavLink>
              </li>

              <li>
                <NavLink
                  to={`${path}/subscription-packages`}
                  onClick={addParentActive}
                >
                  {t("subscriptionPackages.subscriptionPackages")}
                </NavLink>
              </li>
              <li>
                <NavLink to={`${path}/branches`} onClick={addParentActive}>
                  {t("branches.branches")}
                </NavLink>
              </li>
              <li>
                <NavLink to={`${path}/qr-codes`} onClick={addParentActive}>
                  {t("qrcodes.qrcodes")}
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="has-subMenu">
            <Link to="#" className="parent">
              {t("reports.reports")}
            </Link>
            <ul className="subMenu">
              <li>
                <NavLink
                  to={`${path}/reports/subscriptions`}
                  onClick={addParentActive}
                >
                  {t("subscriptions.subscriptions")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`${path}/reports/payments`}
                  onClick={addParentActive}
                >
                  {t("payments.payments")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`${path}/reports/members`}
                  onClick={addParentActive}
                >
                  {t("members.members")}
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="has-subMenu">
            <Link to="#" className="parent">
              {t("employees.employees")}
            </Link>
            <ul className="subMenu">
              <li>
                <NavLink to={`${path}/employees`} onClick={addParentActive}>
                  {t("employees.employeesList")}
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </TopMenuStyle>
  );
}

export default TopMenu;
